//import { InjectableCompiler } from "@angular/compiler/src/injectable_compiler";
import { Injectable } from "@angular/core";

declare global{
    export interface Window{
        analyticsDataLayer:any;
        // _satellite:{track:any};
        _satellite:any;
    }
}

@Injectable({
    providedIn:'root'
})
export class TrackerOmnitureService{
    constructor(){
    }

  trackPage(pageName: string) {
    if (window._satellite && typeof window._satellite.track === 'function') {
      window._satellite.track("pageView");
    } else {
      console.warn('window._satellite.track is not available');
    }
  }
    
    // trackPageloadData(pageName:string,userID:string){
    //     this.resetContentInfo();
    //    const  pageInfo={
    //         pageName:pageName,
    //         userID:userID,
    //         applicationName:'Gatepass Automation'
    //     };
    //    window.analyticsDataLayer = pageInfo;
       
    // }

     trackPageloadData(pageName:string,userID:string){
        this.resetContentInfo();
        window.analyticsDataLayer = {
            pageInfo:{
                pageName:pageName,
                userID:userID,
                applicationName:'Gatepass Automation'
            },         
        };     
    }
    resetContentInfo(){
        window.analyticsDataLayer ={};
    }
    setCommonInfo(){
        window.analyticsDataLayer = {
            page:{
                pageInfo:{
                    pageName:'',
                    userID:'',
                    applicationName:'Gatepass Automation'
                },
            }
        };
    }
}
